<template>
	<div>
		<!-- cabecalho -->
		<div class="fl-cabecalho no-print">
			<div class="row">
				<div class="col-md-4 col-xs-12">
					<i class="icon" :class="icon"></i>
					<!-- <h3>{{titulo}}</h3>
				<h4>{{subtitulo}}</h4> -->
					<h3>{{ _traducao('global', 'despacho').toUpperCase() }}</h3>
					<h4>{{ _traducao('menuMonitoramento', 'menuMonitoraAeronaves').toUpperCase() }}</h4>
				</div>

				<div class="col-md-4 col-xs-12">
					<i class="icon icon-vizualizar icon-sub"></i>
					<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
					<h4>{{ _traducao('global', 'diarioDeBordo').toUpperCase() }}</h4>
				</div>

				<div class="col-md-4 col-xs-12">
					<button @click="$emit('volta-lista')" class="btn btn-default pull-right btn-lg" :title="_traducao('global', 'voltar')">
						<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
					</button>

					<button
						class="btn btn-default pull-right btn-lg"
						:title="_traducao('global', 'imprimir')"
						style="margin-right: 20px"
						@click="_print()"
					>
						<i class="icon-imprimir" style="font-size: 18px"></i>
					</button>
				</div>
			</div>
		</div>

		<div>
			<div class="row no-print" style="margin-top: 10px">
				<div class="col-xs-12">
					<p class="text-info" style="margin-bottom: 20px">
						<i class="fa fa-fw fa-info-circle"></i> {{ _traducao('global', 'cliqueTrechoCarregar') }}
					</p>
				</div>
			</div>

			<div class="visualizar-diario" v-for="(item, index) in relatorio_voo_trecho" :key="index">
				<div class="row">
					<div class="col-xs-12">
						<table class="tb no-print" style="width: 100%; cursor: pointer; padding: 4px">
							<tbody>
								<tr @click="carregaDiario(item.id, index)">
									<td style="width: 20%; padding-left: 4px">
										<h5 style="margin-bottom: 0px">{{ item.estado_inicio_missao }}</h5>
										<h4 style="margin-top: 0px">{{ item.cidade_inicio_missao }}</h4>
									</td>
									<td style="width: 4%">
										<h4>
											<i class="fa fa-arrow-right" aria-hidden="true"></i>
										</h4>
									</td>
									<td style="width: 17%">
										<h5 style="margin-bottom: 0px">{{ item.estado_termino_missao }}</h5>
										<h4 style="margin-top: 0px">{{ item.cidade_termino_missao }}</h4>
									</td>
									<td style="width: 17%" v-if="!_isMobile">
										<h5 style="margin-bottom: 0px">{{ _traducao('global', 'aeronave') }}</h5>
										<h4 style="margin-top: 0px">{{ item.prefixo }}</h4>
									</td>
									<td style="width: 17%" v-if="!_isMobile">
										<h5 style="margin-bottom: 0px">{{ _traducao('global', 'diario') }}</h5>
										<h4 style="margin-top: 0px">{{ item.numero_diario }}</h4>
									</td>
									<td style="width: 17%">
										<h5 style="margin-bottom: 0px">{{ _traducao('global', 'tempoDeVoo') }}</h5>
										<h4 style="margin-top: 0px">
											{{ item.tempo_voo_piloto | horimetro }} <small>({{ _traducao('global', 'piloto') }})</small>
										</h4>
									</td>
									<td style="width: 5%" class="no-print text-right">
										<i style="font-size: 40px" v-if="!item.exibir" class="fa fa-angle-down" aria-hidden="true"></i>
										<i style="font-size: 40px" v-if="item.exibir" class="fa fa-angle-up" aria-hidden="true"></i>
									</td>
								</tr>
							</tbody>
						</table>

						<div>
							<flDiarioDeBordo
								v-show="item.exibir"
								ref="diario"
								:cabecalho="false"
								:voo="false"
								:visualizar="true"
							></flDiarioDeBordo>
						</div>
					</div>
				</div>
			</div>

			<div class="row no-print">
				<div class="col-xs-12">
					<div style="border: 1px solid #2196f3; padding: 6px; border-radius: 8px; margin-bottom: 8px">
						<h4 class="text-right" style="margin-right: 8%">
							{{ _traducao('global', 'tempoTotalPiloto') }} <strong>{{ tempo_voo_piloto | horimetro }}</strong>
						</h4>
					</div>
				</div>
			</div>

			<div class="print text-center" style="font-size: 16px">
				<STRONG>{{ _traducao('global', 'tempoTotalPiloto').toUpperCase() }} {{ tempo_voo_piloto | horimetro }}</STRONG>
			</div>
		</div>
	</div>
</template>

<style scoped>
.tb > tbody > tr:hover {
	background: #f0f0f0;
}

.visualizar-diario {
	border: 1px solid #2196f3;
	padding: 6px;
	border-radius: 8px;
	margin-bottom: 8px;
}

@media print {
	.visualizar-diario {
		border: 1px solid #2196f3;
		padding: 0px;
		border-radius: 8px;
		margin-bottom: 6px;
	}

	h4 {
		font-size: 14px;
		padding: 0px;
	}

	.tb {
		margin-bottom: 0px;
	}

	.diario-visualizar {
		margin-top: -16px;
		padding-bottom: 6px;
	}
}
</style>

<script>
export default {
	props: {
		icon: {
			type: String,
			required: true
		},
		titulo: {
			type: String,
			required: true
		},
		subtitulo: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			relatorio_voo_trecho: [],
			tempo_voo_piloto: 0,
			cliente: 'mg-siga'
		}
	},

	methods: {
		carrega(lista) {
			if ($cliente.get('id') == 10) {
				this.cliente = 'cta-maranhao'
			}
			this.relatorio_voo_trecho = []
			this.tempo_voo_piloto = 0
			this.relatorio_voo_trecho = lista.map((item) => {
				item.exibir = false
				item.carregado = false

				this.tempo_voo_piloto += Number(item.tempo_voo_piloto)

				return item
			})
			//this.$refs.modalVisualizarDiario.modalShow()
		},

		carregaDiario(idDiario, index) {
			if (!this.relatorio_voo_trecho[index].carregado) {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._carregaDiarioExterno(idDiario, this.cliente, (retorno) => {
					this.relatorio_voo_trecho[index].carregado = true
					this.relatorio_voo_trecho[index].exibir = true

					bus.$emit('load-out')
					this.$refs.diario[index].editarDiarioDeBordo({trecho: retorno.trecho, aero: retorno.aero})
					this.$forceUpdate()
				})
			} else {
				this.relatorio_voo_trecho[index].exibir = !this.relatorio_voo_trecho[index].exibir
				this.$forceUpdate()
			}
		}
	}
}
</script>